// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ImageCarousel_carousel__k89sE","slide":"ImageCarousel_slide__rm7VS","active":"ImageCarousel_active__ffaoZ"};